import { Controller } from "@hotwired/stimulus"

export default class MenuController extends Controller {
static targets = ["menuLink"]

connect() {
    const platform = this.detectPlatform()
    this.addPlatformParam(platform)
}

  addPlatformParam(platform) {
    if (platform === "other") return

    const link = this.menuLinkTarget
    const url = new URL(link.href, window.location.origin)

    if (!url.searchParams.has("platform")) {
      url.searchParams.set("platform", platform)
      link.href = url.toString()
    }
  }

    detectPlatform() {
    const ua = navigator.userAgent.toLowerCase()
    if (/android/.test(ua)) return "android"
    if (/iphone|ipad|ipod/.test(ua)) return "ios"
    return "other" // desktop, Mac, Windows, Linux, itd.
  }
}
